exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ListingSwiperPhotos-listPhotoContainer-lNpWK {\n\tposition: relative;\n\twidth: 100%;\n\theight: 100%;\n}\n\n.ListingSwiperPhotos-parent-9buud {\n\tpadding-top: 66.6667%;\n\tposition: relative;\n\theight: auto;\n}\n\n.ListingSwiperPhotos-imageContent-eH0-D {\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tleft: 0;\n\theight: 100%;\n\twidth: 100%;\n\tbackground-position: 50% 50%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\tborder-radius: 15px;\n\tbackground-color: var(--background-gray-secondary-color);\n}\n\n.ListingSwiperPhotos-sliderItem-fCioL {\n\tpadding: 1px !important;\n}", ""]);

// exports
exports.locals = {
	"listPhotoContainer": "ListingSwiperPhotos-listPhotoContainer-lNpWK",
	"parent": "ListingSwiperPhotos-parent-9buud",
	"imageContent": "ListingSwiperPhotos-imageContent-eH0-D",
	"sliderItem": "ListingSwiperPhotos-sliderItem-fCioL"
};